import SaleSheetUpload from './SaleSheetUpload';
import CreateDeduction from './CreateDeduction';
import EmployeeSalesReport from './EmployeeSalesReport';

export { EmployeeSalesReport, CreateDeduction, SaleSheetUpload };
